import { createAsyncThunk } from '@reduxjs/toolkit';

import updateResourcesFromSettingProfile from '../services/updateResourcesFromSettingProfile';

/**
 * Thunk to update users resources and user
 * @param {Object} updates - The updates to be applied to the resources.
 * @returns {Object} - The updated resources
 */
export const setUpdateResourcesFromSettingProfile = createAsyncThunk(
  'users/setUpdateResourcesFromSettingProfile',
  async (updates, { getState }) => {
    // const state = getState();

    const updatedResources = await updateResourcesFromSettingProfile(updates);
    console.log('updatedResources:', updatedResources)

    return updatedResources;
  }
);